import { filterEmptyProps } from '@/utils/common';
import { userSelectServeUrl } from '@/store/modules/data-center/shared';
import { request } from '../request';

/**
 * OTA看板查看正在升级的任务
 *
 * @param params
 * @returns
 */
export const fetchGetFirmwareUpdataList = (params?: Api.Device.FirmwareParams) => {
  return request<Api.Device.FirmwareList>({
    url: `${userSelectServeUrl()}/developer-platform/api/firmware/ota/task/board/query`,
    method: 'get',
    params: filterEmptyProps(params)
  });
};

/**
 * 查询用户常用产品
 *
 * @returns
 */
export const fetchGetCommonProduct = () => {
  return request<Api.Device.CommonProductList>({
    url: `${userSelectServeUrl()}/developer-platform/api/firmware/ota/task/products/common`,
    method: 'get'
  });
};

/**
 * 获取固件版本列表
 *
 * @returns
 */
export const fetchGetTaskVersionList = (params: Api.Device.TaskVersionParams) => {
  return request<Api.Device.TaskVersionList>({
    url: `${userSelectServeUrl()}/developer-platform/api/firmware/ota/task/versionList`,
    method: 'get',
    params
  });
};

/**
 * 创建OTA任务
 *
 * @param params
 * @returns
 */
export const fetchPostOtaTaskCreate = (params: Api.Device.OtaTaskCreated) => {
  return request({
    url: `${userSelectServeUrl()}/developer-platform/api/firmware/ota/task/create`,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    method: 'post',
    data: params
  });
};

/**
 * 查看OTA升级任务列表
 *
 * @param params
 * @returns
 */
export const fetchGetOtaTaskList = (params: Api.Device.OtaTaskAllParmas) => {
  return request<Api.Device.OtaAllTaskList>({
    url: `${userSelectServeUrl()}/developer-platform/api/firmware/ota/task/query/list`,
    method: 'get',
    params
  });
};

/**
 * 批量删除OTA任务
 *
 * @param taskIds
 * @returns
 */
export const fetchPostOtaTaskRemove = (taskIds: string) => {
  return request<Api.Device.OtaAllTaskList>({
    url: `${userSelectServeUrl()}/developer-platform/api/firmware/ota/task/remove`,
    method: 'post',
    params: {
      taskIds
    }
  });
};

/**
 * 查看OTA升级任务详情
 *
 * @param params
 * @returns
 */
export const fetchGetOtaTaskDeatil = (params: Api.Device.OtaTaskDetailParmas) => {
  return request<Api.Device.OtaTaskDetailList>({
    url: `${userSelectServeUrl()}/developer-platform/api/firmware/ota/task/query/detail`,
    method: 'get',
    params
  });
};

/**
 * 失败设备批量重新升级
 *
 * @param params
 * @returns
 */
export const fetchPostOtaRetry = (data: Api.Device.OtaUpdateNow) => {
  return request({
    url: `${userSelectServeUrl()}/developer-platform/api/firmware/ota/task/devicesRetryOta`,
    method: 'post',
    data
  });
};

/**
 * 设备立即升级
 *
 * @param params
 * @returns
 */
export const fetchPostOtaNow = (deviceOtaTaskId: string) => {
  return request({
    url: `${userSelectServeUrl()}/developer-platform/api/firmware/ota/task/devicesOtaNow`,
    method: 'post',
    params: {
      deviceOtaTaskId
    }
  });
};


/**
 * 开始OTA任务
 *
 * @param taskId
 * @returns
 */
export function fetchStartOtaTaskStatus(data: any) {
  return request<number>({
    url: '/developer-platform/api/firmware/ota/task/startOtaTask',
    method: 'POST',
    data
  });
}

/**
 * 暂停OTA任务
 *
 * @param taskId
 * @returns
 */
export function fetchSuspendOtaTaskStatus(data: any) {
  return request<number>({
    url: '/developer-platform/api/firmware/ota/task/suspendOtaTask',
    method: 'POST',
    data
  });
}

/**
 * 取消的OTA任务重新升级
 *
 * @param taskId
 * @returns
 */
export function fetchRestartDeviceOtaTask(data: any) {
  return request<number>({
    url: '/developer-platform/api/firmware/ota/task/restartOtaTask',
    method: 'POST',
    data
  });
}

/**
 * 取消OTA任务
 *
 * @param taskId
 * @returns
 */
export function fetchCancelOtaTask(data: any) {
  return request<number>({
    url: '/developer-platform/api/firmware/ota/task/cancelOtaTask',
    method: 'POST',
    data
  });
}



